module.exports = __webpack_public_path__ + "static/img/manto-2.e8610af0.jpg";